import { FC } from 'react';
import { IconProps } from '../../types';

export const Iron: FC<IconProps> = ({ width = 15, height = 15, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5Z"
        fill="url(#paint0_linear_6141_57878)"
      />
      <path d="M7.13991 3.588H8.33991V11.988H7.13991V3.588Z" fill="#E3E3E3" />
      <defs>
        <linearGradient
          id="paint0_linear_6141_57878"
          x1="7"
          y1="18"
          x2="7"
          y2="-3.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#402F2F" />
          <stop offset="0.239" stopColor="#68666F" />
          <stop offset="0.47" stopColor="#A8A2A2" />
          <stop offset="1" stopColor="#6C5858" />
        </linearGradient>
      </defs>
    </svg>
  );
};
